import React from 'react';

// Better Italy Outline - Version A (Clean boot shape, open style)
export const LogoItalyA = ({ className = "", color = "current" }) => {
  const strokeColor = color === "current" ? "currentColor" : color === "dark" ? "#1c1917" : "#ffffff";
  const accentColor = "#b45309";
  
  return (
    <svg viewBox="0 0 200 40" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
      {/* Italy boot - more accurate shape */}
      <path
        d="M12 6 L18 4 L22 6 L20 10 L18 14 L20 18 L24 24 L28 28 L26 32 L22 34 L18 32 L14 28 L12 24 L10 20"
        stroke={strokeColor}
        strokeWidth="2"
        fill="none"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      {/* Sicily */}
      <ellipse cx="20" cy="37" rx="4" ry="2" stroke={strokeColor} strokeWidth="2" fill="none" />
      {/* Accent dot (Rome area) */}
      <circle cx="17" cy="20" r="2" fill={accentColor} />
      {/* Text */}
      <text x="40" y="26" fontFamily="'Playfair Display', Georgia, serif" fontSize="17" fontWeight="500" fill={strokeColor} letterSpacing="-0.02em">
        Italian Insiders
      </text>
    </svg>
  );
};

// Better Italy Outline - Version B (Filled silhouette, minimal)
export const LogoItalyB = ({ className = "", color = "current" }) => {
  const fillColor = color === "current" ? "currentColor" : color === "dark" ? "#1c1917" : "#ffffff";
  const accentColor = "#b45309";
  
  return (
    <svg viewBox="0 0 200 40" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
      {/* Italy boot - solid fill, accurate shape */}
      <path
        d="M16 3C18 2 21 3 22 5C22 7 21 9 20 12C19 15 19 17 20 20C21 23 23 26 25 28C27 30 28 32 27 34C26 35 24 35 22 34C20 33 18 31 16 28C14 25 13 22 12 19C11 16 11 13 12 10C13 7 14 4 16 3Z"
        fill={fillColor}
      />
      {/* Sicily */}
      <ellipse cx="22" cy="38" rx="4" ry="1.5" fill={fillColor} />
      {/* Accent dot (Rome) */}
      <circle cx="17" cy="18" r="2" fill={accentColor} />
      {/* Text */}
      <text x="38" y="26" fontFamily="'Playfair Display', Georgia, serif" fontSize="17" fontWeight="500" fill={fillColor} letterSpacing="-0.02em">
        Italian Insiders
      </text>
    </svg>
  );
};

// Better Italy Outline - Version C (Outline with more detail)
export const LogoItalyC = ({ className = "", color = "current" }) => {
  const strokeColor = color === "current" ? "currentColor" : color === "dark" ? "#1c1917" : "#ffffff";
  const accentColor = "#b45309";
  
  return (
    <svg viewBox="0 0 200 40" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
      {/* Italy - proper boot outline */}
      <path
        d="M14 5C17 3 20 4 21 6L20 8L19 12L18 16L19 20L21 24L24 28L27 31L26 34L23 35L19 33L15 29L13 25L11 20L11 15L12 10L14 5Z"
        stroke={strokeColor}
        strokeWidth="2"
        fill="none"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      {/* Sicily as triangle */}
      <path d="M18 36L22 38L26 36" stroke={strokeColor} strokeWidth="2" fill="none" strokeLinecap="round" strokeLinejoin="round" />
      {/* Sardinia small */}
      <ellipse cx="8" cy="18" rx="2" ry="3" stroke={strokeColor} strokeWidth="1.5" fill="none" />
      {/* Accent dot */}
      <circle cx="16" cy="20" r="2" fill={accentColor} />
      {/* Text */}
      <text x="38" y="26" fontFamily="'Playfair Display', Georgia, serif" fontSize="17" fontWeight="500" fill={strokeColor} letterSpacing="-0.02em">
        Italian Insiders
      </text>
    </svg>
  );
};

// Better Italy - Version D (Simple iconic boot)
export const LogoItalyD = ({ className = "", color = "current" }) => {
  const fillColor = color === "current" ? "currentColor" : color === "dark" ? "#1c1917" : "#ffffff";
  const accentColor = "#b45309";
  
  return (
    <svg viewBox="0 0 200 40" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
      {/* Simple iconic Italy boot */}
      <path
        d="M18 2C20 2 22 4 22 6C22 8 21 11 20 14C19 17 18 19 19 22C20 25 22 28 25 31C27 33 28 35 26 37C24 38 21 37 18 35C15 33 13 30 11 26C9 22 9 18 10 14C11 10 13 6 15 4C16 3 17 2 18 2Z"
        fill={fillColor}
      />
      {/* Sicily */}
      <circle cx="23" cy="39" r="2.5" fill={fillColor} />
      {/* Accent - small heart or pin for Rome */}
      <circle cx="16" cy="19" r="1.5" fill={accentColor} />
      <path d="M16 19L16 22" stroke={accentColor} strokeWidth="1.5" strokeLinecap="round" />
      {/* Text */}
      <text x="36" y="26" fontFamily="'Playfair Display', Georgia, serif" fontSize="17" fontWeight="500" fill={fillColor} letterSpacing="-0.02em">
        Italian Insiders
      </text>
    </svg>
  );
};

// Better Italy - Version E (Elegant partial outline)
export const LogoItalyE = ({ className = "", color = "current" }) => {
  const strokeColor = color === "current" ? "currentColor" : color === "dark" ? "#1c1917" : "#ffffff";
  const fillColor = color === "current" ? "currentColor" : color === "dark" ? "#1c1917" : "#ffffff";
  const accentColor = "#b45309";
  
  return (
    <svg viewBox="0 0 200 40" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
      {/* Italy boot - partial/open elegant style */}
      <path
        d="M20 3C22 4 23 7 22 10C21 13 20 16 20 19C20 22 21 25 23 28C25 31 27 33 27 35"
        stroke={strokeColor}
        strokeWidth="2.5"
        fill="none"
        strokeLinecap="round"
      />
      <path
        d="M14 8C12 11 11 15 11 19C11 23 12 27 15 30C17 32 20 34 23 35"
        stroke={strokeColor}
        strokeWidth="2.5"
        fill="none"
        strokeLinecap="round"
      />
      {/* Sicily dot */}
      <circle cx="22" cy="38" r="2" fill={fillColor} />
      {/* Rome accent */}
      <circle cx="16" cy="20" r="2.5" fill={accentColor} />
      {/* Text */}
      <text x="38" y="26" fontFamily="'Playfair Display', Georgia, serif" fontSize="17" fontWeight="500" fill={fillColor} letterSpacing="-0.02em">
        Italian Insiders
      </text>
    </svg>
  );
};

export const logoOptionsV2 = [
  { id: 'italy-a', name: 'Boot Outline', component: LogoItalyA, description: 'Clean boot shape with open strokes' },
  { id: 'italy-b', name: 'Solid Silhouette', component: LogoItalyB, description: 'Filled boot shape, minimal' },
  { id: 'italy-c', name: 'Detailed Outline', component: LogoItalyC, description: 'With Sardinia island' },
  { id: 'italy-d', name: 'Iconic Boot', component: LogoItalyD, description: 'Simple solid with pin marker' },
  { id: 'italy-e', name: 'Elegant Partial', component: LogoItalyE, description: 'Two-stroke elegant style' },
];

export default LogoItalyB;
